export default __webpack_public_path__ + "static/we_deliver-52f6f12ee639af92141a1fe9be3ce26a.webp";